module.exports = __webpack_public_path__ + "static/media/las_vegas_team.31ec2e8c.jpg";